/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Danish (Denmark)
export default {
  'company-hub.carousel-extension.card-strip.card.label': 'slide {positionInSet} af {setSize}',
  'company-hub.carousel-extension.carousel-content.extra-small-frame.placeholder-title': 'Tilføj en titel',
  'company-hub.carousel-extension.carousel-navigation.pause': 'Sæt på pause',
  'company-hub.carousel-extension.carousel-navigation.play': 'Afspil',
  'company-hub.carousel-extension.carousel-navigation.row-orientation.next': 'Næste',
  'company-hub.carousel-extension.carousel-navigation.row-orientation.previous': 'Forrige',
  'company-hub.carousel-extension.config-panel.add-frame-cta': 'Tilføj ramme',
  'company-hub.carousel-extension.config-panel.field.frames.error.invalid-list': 'Tilføj rammer',
  'company-hub.carousel-extension.config-panel.layout.title': 'Vælg et layout',
  'company-hub.carousel-extension.config-panel.layouts.frame-above-image.label': 'Tekst med ramme over billedet',
  'company-hub.carousel-extension.config-panel.layouts.solid-color-background.label': 'Ensfarvet baggrund',
  'company-hub.carousel-extension.config-panel.layouts.split-design-content.label': 'Opdelt design',
  'company-hub.carousel-extension.config-panel.link.field.label': 'Link',
  'company-hub.carousel-extension.config-panel.lozenge.label.updated': 'OPDATERET',
  'company-hub.carousel-extension.config-panel.navigation.progress-circles': 'Statuscirkler',
  'company-hub.carousel-extension.config-panel.navigation.thumbnails': 'Miniaturebilleder',
  'company-hub.carousel-extension.config-panel.preamble-link.label-v2': 'Læs mere om karruseller',
  'company-hub.carousel-extension.config-panel.preamble-v2':
    'Design et sæt med op til {number} roterende rammer. {supportLink}',
  'company-hub.carousel-extension.config-panel.preamble-v2-without-support-link':
    'Design et sæt med op til {number} roterende rammer.',
  'company-hub.carousel-extension.config-panel.style.general.title': 'Generelt',
  'company-hub.carousel-extension.config-panel.style.navigation.title': 'Navigation',
  'company-hub.carousel-extension.config-panel.styles.autoplay-label': 'Automatisk afspilning',
  'company-hub.carousel-extension.config-panel.styles.autoplay-tooltip-content':
    'Indstil karrusellen til at rotere automatisk hvert {number}. sekund i visningstilstand',
  'company-hub.carousel-extension.config-panel.tab.content.label': 'Indhold',
  'company-hub.carousel-extension.config-panel.tab.styles.label': 'Stile',
  'company-hub.carousel-extension.config-panel.title': 'Karrusel',
  'company-hub.carousel-extension.description.field.label': 'Beskrivelse',
  'company-hub.carousel-extension.description.placeholder': 'Tilpas denne ramme for at oprette en roterende karrusel.',
  'company-hub.carousel-extension.frame-spotlight.label': 'ramme {positionInSet} af {setSize}',
  'company-hub.carousel-extension.frame.background.color': 'Baggrundsfarve',
  'company-hub.carousel-extension.frame.color-contrast.fail':
    'Dine valgte farver til tekst og baggrund er ikke gode i forhold til læsbarhed.',
  'company-hub.carousel-extension.frame.color-contrast.success':
    'Dine valgte farver til tekst og baggrund er gode i forhold til læsbarhed.',
  'company-hub.carousel-extension.frame.text.color': 'Tekstfarve',
  'company-hub.carousel-extension.hub-element.description': 'Et roterende sæt flotte rammer',
  'company-hub.carousel-extension.hub-element.title': 'Karrusel',
  'company-hub.carousel-extension.manifest.macro-description': 'Opret en roterende trio med dynamiske rammer.',
  'company-hub.carousel-extension.manifest.macro-title': 'Karrusel',
  'company-hub.carousel-extension.manifest.macro-title.updated': 'Karrusel [opdateret]',
  'company-hub.carousel-extension.placeholder.description': 'Tilpas denne ramme for at oprette en roterende karrusel.',
  'company-hub.carousel-extension.placeholder.title': 'Giv rammen en titel',
  'company-hub.carousel-extension.recommended.field.label': '(Anbefalet)',
  'company-hub.carousel-extension.title.field.label': 'Titel',
  'company-hub.carousel-extension.title.placeholder': 'Giv rammen en titel',
};
